import './global.css'
import App from './App'
import ReactDom from 'react-dom/client'
import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY)

ReactDom.createRoot(document.getElementById('root')!).render(<App />)
